import React from 'react'
import { Percent } from 'react-feather'

const FormDashboardInputPercent = ({className, defaultValue, small, ...props}) => {
  return (
    <div
      className={`custom-input-number text-sm rounded border bg-white flex justify-between items-center ${className}`}
      style={{borderColor: '#ddd'}}
    >
      <input
        className={`${small ? 'px-2 py-1' : 'p-2'} w-full`}
        type="number"
        defaultValue={defaultValue}
        {...props}
      />
      <div className={`${small ? 'p-1' : 'p-2'} lg:pr-4 cursor-pointer`}>
        <Percent width={14} height={16}/>
      </div>
    </div>
  )
}

export { FormDashboardInputPercent }
